module.exports = __webpack_public_path__ + "static/img/icon_q.8175778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_q.svg
// module id = cH1F
// module chunks = 10